import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const routes: RouteRecordRaw[] = [
  { path: "/", component: () => import("@/pages/Home.vue") },
  { path: "/login", component: () => import("@/pages/Login.vue") },
  {
    path: "/account",
    component: () => import("@/pages/Account.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    meta: { requiresAuth: true },
    children: [
      { path: "", component: () => import("@/pages/dashboard/Index.vue") },
      { path: "files", component: () => import("@/pages/dashboard/Files.vue") },
      { path: "account", component: () => import("@/pages/dashboard/Account.vue") },
      {
        path: "docs",
        component: () => import("@/pages/dashboard/docs/Index.vue"),
      },
      {
        path: "docs/new",
        component: () => import("@/pages/dashboard/docs/New.vue"),
      },
      {
        path: "docs/:id",
        component: () => import("@/pages/dashboard/docs/Edit.vue"),
      },
      {
        path: "blog",
        component: () => import("@/pages/dashboard/Blog.vue"),
        meta: { role: ["admin", "staff"] },
      },
    ],
  },
  { path: "/:pathMatch(.*)*", component: () => import("@/pages/NotFound.vue") },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  if (!auth.loaded) await auth.refresh();
  if (to.meta.requiresAuth && !auth.user) {
    return { path: "/login", query: { redirect: to.fullPath } };
  }
  if (to.meta.role) {
    const roles = Array.isArray(to.meta.role) ? to.meta.role : [to.meta.role];
    if (!auth.user || !roles.includes(auth.user.role)) {
      return { path: "/" };
    }
  }
});

export default router;
